export default __webpack_public_path__ + "static/media/CEPB.73c12e96.png";